var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M5.708 10.293L14.9 1.1a1 1 0 1 1 1.415 1.414L7.829 11l8.486 8.485A1 1 0 1 1 14.9 20.9l-9.192-9.192a1 1 0 0 1 0-1.414z"}})}
var staticRenderFns = []

export { render, staticRenderFns }